import template from './mySolidarity.html';
import './mySolidarity.scss';
import controller from './mySolidarity.controller';

let mySolidarity = {
  restrict: 'E',
  bindings: {},
  controller,
  template,
};

export default mySolidarity;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/mySolidarity.component.js